import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqItems = [
  {
    question: "Cât durează un detailing complet?",
    answer: "Un detailing complet (interior + exterior) durează între 1-3 zile, în funcție de starea vehiculului și de serviciile solicitate. Noi nu ne grăbim - calitatea este prioritatea noastră.",
  },
  {
    question: "Ce înseamnă protecția ceramică și cât durează?",
    answer: "Protecția ceramică este un strat nano-ceramic aplicat pe vopseaua mașinii care oferă protecție de lungă durată împotriva zgârieturilor minore, razelor UV, contaminanților chimici și apă. Crystal Serum Ultra de la Gtechniq durează până la 9 ani.",
  },
  {
    question: "Cât costă un polish auto profesional?",
    answer: "Prețul variază în funcție de dimensiunea vehiculului, starea vopselei și numărul de etape de corecție necesare. Contactează-ne pentru o ofertă personalizată bazată pe o evaluare a mașinii tale.",
  },
  {
    question: "Ce este PPF (Paint Protection Film)?",
    answer: "PPF este o folie transparentă, extrem de rezistentă, aplicată pe caroserie pentru a proteja vopseaua de pietre, zgârieturi, insecte și alte agresiuni. Este invizibilă și se auto-repară la căldură.",
  },
  {
    question: "Lucrați cu programare sau pot veni oricând?",
    answer: "Lucrăm exclusiv cu programare pentru a asigura că fiecare vehicul primește atenția necesară. Programează-te telefonic la 0761 712 940 sau pe WhatsApp.",
  },
  {
    question: "Ce produse folosiți?",
    answer: "Folosim exclusiv produse profesionale premium: Gtechniq, Crystal Serum Ultra, Koch Chemie, Gyeon și altele. Suntem certificați Gtechniq Accredited Detailer.",
  },
  {
    question: "Oferiți garanție pentru servicii?",
    answer: "Da! Toate serviciile noastre vin cu garanție. Protecția ceramică Crystal Serum Ultra vine cu garanție de până la 9 ani, iar folia PPF are garanție de la producător.",
  },
  {
    question: "Pot aștepta mașina în timp ce lucrați la ea?",
    answer: "Pentru servicii rapide precum spălarea premium, da. Pentru servicii complexe (detailing complet, PPF, ceramică), vehiculul rămâne în centru 1-3 zile. Vă ținem la curent cu progresul.",
  },
];

export default function FAQ() {
  return (
    <div className="pt-20 min-h-screen bg-black" data-testid="faq-page">
      {/* Header */}
      <section className="py-20 page-header-bg">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <motion.h1
            className="text-4xl sm:text-5xl lg:text-6xl mb-4"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Intrebari <span className="text-red-600">Frecvente</span>
          </motion.h1>
          <motion.div
            className="red-line mx-auto mb-6"
            initial={{ width: 0 }}
            animate={{ width: 60 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          />
          <motion.p
            className="text-base md:text-lg font-light max-w-2xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            style={{ fontFamily: "'Raleway', sans-serif" }}
          >
            Găsește răspunsuri la cele mai frecvente întrebări despre serviciile noastre.
          </motion.p>
        </div>
      </section>

      {/* FAQ Accordion */}
      <section className="py-24 bg-[#050505]">
        <div className="max-w-3xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <Accordion type="single" collapsible className="space-y-4">
              {faqItems.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border border-[#222] bg-[#0A0A0A] px-6 hover:border-red-600/50 transition-colors duration-300"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger
                    className="text-left text-white hover:text-red-500 hover:no-underline py-5"
                    style={{ fontFamily: "'Playfair Display', serif", fontSize: "1.15rem" }}
                  >
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent
                    className="text-white font-light leading-relaxed pb-5"
                    style={{ fontFamily: "'Raleway', sans-serif", fontSize: "0.9rem" }}
                  >
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-black">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.h2
            className="text-3xl sm:text-4xl lg:text-5xl mb-6"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            Nu ai gasit <span className="text-red-600">raspunsul</span>?
          </motion.h2>
          <motion.p
            className="text-base md:text-lg mb-10 font-light"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            style={{ fontFamily: "'Raleway', sans-serif" }}
          >
            Contactează-ne direct și îți răspundem cu plăcere la orice întrebare.
          </motion.p>
          <motion.div
            className="flex flex-col sm:flex-row gap-4 justify-center"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <Link
              to="/contact"
              data-testid="faq-contact-btn"
              className="px-10 py-4 bg-red-600 text-white hover:bg-red-700 pulse-glow transition-all duration-300 tracking-[0.15em] uppercase text-sm font-medium"
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              Contactează-ne
            </Link>
            <a
              href="tel:0761712940"
              data-testid="faq-phone-btn"
              className="px-10 py-4 border border-white text-white hover:bg-white hover:text-black transition-all duration-300 tracking-[0.15em] uppercase text-sm font-medium"
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              Sună: 0761 712 940
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
